export const transformItemAuthenticityModalPhotoTipsDto = _ref => {
  let {
    image_url,
    text
  } = _ref;
  return {
    imageUrl: image_url,
    text
  };
};
export const transformItemAuthenticityModalDto = _ref2 => {
  let {
    title,
    subtitle,
    note,
    cta,
    cta_url,
    photo_tips
  } = _ref2;
  return {
    title,
    subtitle,
    note,
    cta,
    ctaUrl: cta_url,
    photoTips: photo_tips === null || photo_tips === void 0 ? void 0 : photo_tips.map(transformItemAuthenticityModalPhotoTipsDto)
  };
};